import { render, staticRenderFns } from "./FeatureEditor.vue?vue&type=template&id=7f470771&scoped=true&"
import script from "./FeatureEditor.vue?vue&type=script&lang=js&"
export * from "./FeatureEditor.vue?vue&type=script&lang=js&"
import style0 from "./FeatureEditor.vue?vue&type=style&index=0&id=7f470771&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f470771",
  null
  
)

export default component.exports